import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { endpoints } from '../services/api';
import AuthShell from '../components/AuthShell';

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const res = await fetch(endpoints.auth.forgotPassword, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });

      if (!res.ok) {
        const errData = await res.json();
        throw new Error(errData.detail || 'Something went wrong.');
      }

      setSubmitted(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell display="Locked out?" say="Happens to everyone. I'll email you a reset link.">
        <h1 className="auth-title">Reset your password</h1>

        {submitted ? (
          <>
            <p className="auth-success">
              If that email is registered, you'll receive a reset link shortly. Check your inbox.
            </p>
            <p className="auth-switch">
              <Link to="/login">Back to login</Link>
            </p>
          </>
        ) : (
          <>
            <p className="auth-subtitle">
              Enter your email and we'll send you a link to reset your password.
            </p>

            <form onSubmit={handleSubmit} className="auth-form">
              {error && <p className="auth-error">{error}</p>}

              <div className="form-group">
                <label htmlFor="email">Email</label>
                <input
                  type="email"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  autoFocus
                />
              </div>

              <button
                type="submit"
                className="cta-button primary auth-button"
                disabled={loading}
              >
                {loading ? 'Sending…' : 'Send reset link'}
              </button>
            </form>

            <p className="auth-switch">
              <Link to="/login">Back to login</Link>
            </p>
          </>
        )}
    </AuthShell>
  );
};

export default ForgotPasswordPage;
